var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"analysis-wrapper"},[_c('div',{staticClass:"section-item"},[_c('over-view')],1),_vm._v(" "),_c('div',{staticClass:"section-item"},[_c('tabs-navigation')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }